import { render, staticRenderFns } from "./TabWidget.vue?vue&type=template&id=1fd8e7be&"
import script from "./TabWidget.vue?vue&type=script&lang=ts&"
export * from "./TabWidget.vue?vue&type=script&lang=ts&"
import style0 from "./TabWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports